export default function hasMarked (reference) {
  if (reference.forms) {
    return reference.forms.find(form => {
      return form.isMarked || (form.forms && hasMarked(form))
    })
  }
}
